var _g, _g2, _path, _path2, _path3, _path4, _g3, _g4, _path5, _path6, _g5, _g6, _path7, _path8, _g7, _g8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_849_9587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6668 29.8193C31.1755 29.219 30.7267 28.3497 29.9399 28.3376C22.8833 28.2287 16.8898 28.3646 9.59712 28.809C8.81186 28.8568 8.40263 29.7452 8.93765 30.322C11.6102 33.2032 15.3896 35 19.5794 35C24.0077 35 27.9776 32.9927 30.6668 29.8193Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07348 12.1598C6.67114 12.8297 7.24275 13.6145 8.01852 13.5208C16.1184 12.5428 22.2272 12.2462 30.6868 12.7494C31.47 12.796 31.9955 11.9733 31.5482 11.3287C28.8908 7.49901 24.5205 5 19.5794 5C14.2892 5 9.65327 7.86456 7.07348 12.1598Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_849_9587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6668 29.8193C31.1755 29.219 30.7267 28.3497 29.9399 28.3376C22.8833 28.2287 16.8898 28.3646 9.59712 28.809C8.81186 28.8568 8.40263 29.7452 8.93765 30.322C11.6102 33.2032 15.3896 35 19.5794 35C24.0077 35 27.9776 32.9927 30.6668 29.8193Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07348 12.1598C6.67114 12.8297 7.24275 13.6145 8.01852 13.5208C16.1184 12.5428 22.2272 12.2462 30.6868 12.7494C31.47 12.796 31.9955 11.9733 31.5482 11.3287C28.8908 7.49901 24.5205 5 19.5794 5C14.2892 5 9.65327 7.86456 7.07348 12.1598Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6668 29.8193C31.1755 29.219 30.7267 28.3497 29.9399 28.3376C22.8833 28.2287 16.8898 28.3646 9.59712 28.809C8.81186 28.8568 8.40263 29.7452 8.93765 30.322C11.6102 33.2032 15.3896 35 19.5794 35C24.0077 35 27.9776 32.9927 30.6668 29.8193Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07348 12.1598C6.67114 12.8297 7.24275 13.6145 8.01852 13.5208C16.1184 12.5428 22.2272 12.2462 30.6868 12.7494C31.47 12.796 31.9955 11.9733 31.5482 11.3287C28.8908 7.49901 24.5205 5 19.5794 5C14.2892 5 9.65327 7.86456 7.07348 12.1598Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6668 29.8193C31.1755 29.219 30.7267 28.3497 29.9399 28.3376C22.8833 28.2287 16.8898 28.3646 9.59712 28.809C8.81186 28.8568 8.40263 29.7452 8.93765 30.322C11.6102 33.2032 15.3896 35 19.5794 35C24.0077 35 27.9776 32.9927 30.6668 29.8193Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07348 12.1598C6.67114 12.8297 7.24275 13.6145 8.01852 13.5208C16.1184 12.5428 22.2272 12.2462 30.6868 12.7494C31.47 12.796 31.9955 11.9733 31.5482 11.3287C28.8908 7.49901 24.5205 5 19.5794 5C14.2892 5 9.65327 7.86456 7.07348 12.1598Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_849_9587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0743 22.3125C34.2319 21.2661 33.417 20.3644 32.3622 20.2793C23.3161 19.5501 16.1297 19.4321 6.79862 19.9169C5.74046 19.9719 4.89937 20.8523 5.02882 21.904C5.13156 22.7387 5.30136 23.552 5.53252 24.3381C5.77115 25.1496 6.55924 25.6496 7.40462 25.6202C16.2597 25.3127 23.205 25.2892 31.7978 25.5205C32.6435 25.5432 33.4275 25.037 33.6597 24.2235C33.8371 23.6023 33.9762 22.9643 34.0743 22.3125Z",
    stroke: "#E33CD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_849_9587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0743 22.3125C34.2319 21.2661 33.417 20.3644 32.3622 20.2793C23.3161 19.5501 16.1297 19.4321 6.79862 19.9169C5.74046 19.9719 4.89937 20.8523 5.02882 21.904C5.13156 22.7387 5.30136 23.552 5.53252 24.3381C5.77115 25.1496 6.55924 25.6496 7.40462 25.6202C16.2597 25.3127 23.205 25.2892 31.7978 25.5205C32.6435 25.5432 33.4275 25.037 33.6597 24.2235C33.8371 23.6023 33.9762 22.9643 34.0743 22.3125Z",
    stroke: "#E33CD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0743 22.3125C34.2319 21.2661 33.417 20.3644 32.3622 20.2793C23.3161 19.5501 16.1297 19.4321 6.79862 19.9169C5.74046 19.9719 4.89937 20.8523 5.02882 21.904C5.13156 22.7387 5.30136 23.552 5.53252 24.3381C5.77115 25.1496 6.55924 25.6496 7.40462 25.6202C16.2597 25.3127 23.205 25.2892 31.7978 25.5205C32.6435 25.5432 33.4275 25.037 33.6597 24.2235C33.8371 23.6023 33.9762 22.9643 34.0743 22.3125Z",
    stroke: "#E33CD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0743 22.3125C34.2319 21.2661 33.417 20.3644 32.3622 20.2793C23.3161 19.5501 16.1297 19.4321 6.79862 19.9169C5.74046 19.9719 4.89937 20.8523 5.02882 21.904C5.13156 22.7387 5.30136 23.552 5.53252 24.3381C5.77115 25.1496 6.55924 25.6496 7.40462 25.6202C16.2597 25.3127 23.205 25.2892 31.7978 25.5205C32.6435 25.5432 33.4275 25.037 33.6597 24.2235C33.8371 23.6023 33.9762 22.9643 34.0743 22.3125Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_849_9587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91321 16.625C6.86833 15.125 8.82345 15.125 10.7786 16.625C12.7337 18.125 14.6888 18.125 16.6439 16.625C18.5991 15.125 20.5542 15.125 22.5093 16.625C24.4644 18.125 26.4196 18.125 28.3747 16.625C30.3298 15.125 32.2849 15.125 34.2401 16.625",
    stroke: "#00CCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_849_9587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91321 16.625C6.86833 15.125 8.82345 15.125 10.7786 16.625C12.7337 18.125 14.6888 18.125 16.6439 16.625C18.5991 15.125 20.5542 15.125 22.5093 16.625C24.4644 18.125 26.4196 18.125 28.3747 16.625C30.3298 15.125 32.2849 15.125 34.2401 16.625",
    stroke: "#00CCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91321 16.625C6.86833 15.125 8.82345 15.125 10.7786 16.625C12.7337 18.125 14.6888 18.125 16.6439 16.625C18.5991 15.125 20.5542 15.125 22.5093 16.625C24.4644 18.125 26.4196 18.125 28.3747 16.625C30.3298 15.125 32.2849 15.125 34.2401 16.625",
    stroke: "#00CCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91321 16.625C6.86833 15.125 8.82345 15.125 10.7786 16.625C12.7337 18.125 14.6888 18.125 16.6439 16.625C18.5991 15.125 20.5542 15.125 22.5093 16.625C24.4644 18.125 26.4196 18.125 28.3747 16.625C30.3298 15.125 32.2849 15.125 34.2401 16.625",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_849_9587)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.736837,
    cy: 0.559799,
    rx: 0.736837,
    ry: 0.559799,
    transform: "matrix(0.881086 0.472957 0.45642 -0.889764 13.7113 31.3855)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10147,
    cy: 0.748885,
    rx: 1.10147,
    ry: 0.748885,
    transform: "matrix(0.964427 0.264348 -0.25339 0.967364 25.0883 8.75)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.734315,
    cy: 0.561663,
    rx: 0.734315,
    ry: 0.561663,
    transform: "matrix(0.964428 -0.264347 -0.25339 -0.967364 23.5271 31.9749)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4769,
    cy: 10.25,
    rx: 1.09975,
    ry: 0.75,
    transform: "rotate(180 18.4769 10.25)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10147,
    cy: 0.748885,
    rx: 1.10147,
    ry: 0.748885,
    transform: "matrix(0.964427 0.264349 -0.253389 0.967364 20.6893 6.5)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.733173,
    cy: 0.5625,
    rx: 0.733173,
    ry: 0.5625,
    transform: "matrix(1 0 0 -1 18.8435 33.125)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10526,
    cy: 0.746399,
    rx: 1.10526,
    ry: 0.746399,
    transform: "matrix(0.881086 -0.472956 0.456421 0.889764 12.2449 9.04541)",
    stroke: "#4C4CFF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_849_9587)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.736837,
    cy: 0.559799,
    rx: 0.736837,
    ry: 0.559799,
    transform: "matrix(0.881086 0.472957 0.45642 -0.889764 13.7113 31.3855)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10147,
    cy: 0.748885,
    rx: 1.10147,
    ry: 0.748885,
    transform: "matrix(0.964427 0.264348 -0.25339 0.967364 25.0883 8.75)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.734315,
    cy: 0.561663,
    rx: 0.734315,
    ry: 0.561663,
    transform: "matrix(0.964428 -0.264347 -0.25339 -0.967364 23.5271 31.9749)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4769,
    cy: 10.25,
    rx: 1.09975,
    ry: 0.75,
    transform: "rotate(180 18.4769 10.25)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10147,
    cy: 0.748885,
    rx: 1.10147,
    ry: 0.748885,
    transform: "matrix(0.964427 0.264349 -0.253389 0.967364 20.6893 6.5)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.733173,
    cy: 0.5625,
    rx: 0.733173,
    ry: 0.5625,
    transform: "matrix(1 0 0 -1 18.8435 33.125)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10526,
    cy: 0.746399,
    rx: 1.10526,
    ry: 0.746399,
    transform: "matrix(0.881086 -0.472956 0.456421 0.889764 12.2449 9.04541)",
    stroke: "#4C4CFF"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.736837,
    cy: 0.559799,
    rx: 0.736837,
    ry: 0.559799,
    transform: "matrix(0.881086 0.472957 0.45642 -0.889764 13.7113 31.3855)",
    stroke: "#4C4CFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10147,
    cy: 0.748885,
    rx: 1.10147,
    ry: 0.748885,
    transform: "matrix(0.964427 0.264348 -0.25339 0.967364 25.0883 8.75)",
    stroke: "#4C4CFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.734315,
    cy: 0.561663,
    rx: 0.734315,
    ry: 0.561663,
    transform: "matrix(0.964428 -0.264347 -0.25339 -0.967364 23.5271 31.9749)",
    stroke: "#4C4CFF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4769,
    cy: 10.25,
    rx: 1.09975,
    ry: 0.75,
    transform: "rotate(180 18.4769 10.25)",
    stroke: "#4C4CFF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10147,
    cy: 0.748885,
    rx: 1.10147,
    ry: 0.748885,
    transform: "matrix(0.964427 0.264349 -0.253389 0.967364 20.6893 6.5)",
    stroke: "#4C4CFF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.733173,
    cy: 0.5625,
    rx: 0.733173,
    ry: 0.5625,
    transform: "matrix(1 0 0 -1 18.8435 33.125)",
    stroke: "#4C4CFF"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10526,
    cy: 0.746399,
    rx: 1.10526,
    ry: 0.746399,
    transform: "matrix(0.881086 -0.472956 0.456421 0.889764 12.2449 9.04541)",
    stroke: "#4C4CFF"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.736837,
    cy: 0.559799,
    rx: 0.736837,
    ry: 0.559799,
    transform: "matrix(0.881086 0.472957 0.45642 -0.889764 13.7113 31.3855)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10147,
    cy: 0.748885,
    rx: 1.10147,
    ry: 0.748885,
    transform: "matrix(0.964427 0.264348 -0.25339 0.967364 25.0883 8.75)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.734315,
    cy: 0.561663,
    rx: 0.734315,
    ry: 0.561663,
    transform: "matrix(0.964428 -0.264347 -0.25339 -0.967364 23.5271 31.9749)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4769,
    cy: 10.25,
    rx: 1.09975,
    ry: 0.75,
    transform: "rotate(180 18.4769 10.25)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10147,
    cy: 0.748885,
    rx: 1.10147,
    ry: 0.748885,
    transform: "matrix(0.964427 0.264349 -0.253389 0.967364 20.6893 6.5)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.733173,
    cy: 0.5625,
    rx: 0.733173,
    ry: 0.5625,
    transform: "matrix(1 0 0 -1 18.8435 33.125)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.10526,
    cy: 0.746399,
    rx: 1.10526,
    ry: 0.746399,
    transform: "matrix(0.881086 -0.472956 0.456421 0.889764 12.2449 9.04541)",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_849_9587",
    x: 2.43463,
    y: 0.5,
    width: 33.7848,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_849_9587"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_849_9587",
    x: 2.43463,
    y: 0.5,
    width: 33.7848,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_849_9587"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_849_9587",
    x: 0.515259,
    y: 15.125,
    width: 38.0792,
    height: 14.9963,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_849_9587"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_849_9587",
    x: 0.515259,
    y: 15.125,
    width: 38.0792,
    height: 14.9963,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_849_9587"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_849_9587",
    x: 0.413208,
    y: 11,
    width: 38.3268,
    height: 11.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_849_9587"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_849_9587",
    x: 0.413208,
    y: 11,
    width: 38.3268,
    height: 11.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_849_9587"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_849_9587",
    x: 8.03107,
    y: 2.23315,
    width: 23.5081,
    height: 35.3918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_849_9587"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_849_9587",
    x: 8.03107,
    y: 2.23315,
    width: 23.5081,
    height: 35.3918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_849_9587"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobileLogo.9f5f247366709b8d71ba6abe32b1b0bb.svg";
export { ForwardRef as ReactComponent };